// API Base URL based on environment
export const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:8080/enablement/api'
  : 'https://demo.apty.io/enablement/api'; 
